import React, { Component } from 'react';
import CvPageView from './CvPageView';
import { CVRegistrationApi } from './Api';
import { CVEditApi } from './Api';
import { url } from '../../Server/url/GlobalUrl';

class CvPageComponent extends Component {
  constructor(props) {
    super(props);
    const year = new Date().getFullYear();
    this.years = Array.from(new Array(100), (val, index) => year - index);
  }
  state = {
    email: '',
    password: '',
    confirmpassword: '',
    jobtitle: '',
    title_type: [],
    right_to_work_type: [],
    months_list: [
      { number: '01', text: 'January' },
      { number: '02', text: 'February' },
      { number: '03', text: 'March' },
      { number: '04', text: 'April' },
      { number: '05', text: 'May' },
      { number: '06', text: 'June' },
      { number: '07', text: 'July' },
      { number: '08', text: 'August' },
      { number: '09', text: 'September' },
      { number: '10', text: 'October' },
      { number: '11', text: 'November' },
      { number: '12', text: 'December' },
    ],
    date_list: [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
    ],
    firstname: '',
    lastname: '',
    date: '',
    title: '',
    year: '',
    month: '',
    address: '',
    address1: '',
    zipcode: '',
    country: '',
    city: '',
    right_to_work: '',
    upload_cv: null,
    upload_image: null,
    setpassword_validate: '',
    setemail_validate: '',
    setconfirmpassword_validate: '',
    setfirstname_validate: '',
    setlastname_validate: '',
    setjob_validate: '',
    setaddress_validate: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    longitude: '',
    latitude: '',
    address_list: [],

    setzipcode_validate: '',
    setcountry_validate: '',
    setuploadimage_validate: '',
    setuploadcv_validate: '',
    setuploadimage_validate: '',
    setdate_validate: '',
    setmonth_validate: '',
    setyear_validate: '',
    right_to_work_validate: '',
    modal_show: false,
    upload_cv_name: null,
    upload_image_name: null,
    authResponse: '',
    edit_status: false,
    cv_id: '',
    setcounty_validate: '',
    setcity_validate: '',
    county: '',
    current_user_firstname: '',
    update_record: '',
    update_record_second: '',
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };

  componentDidMount() {
    this.setState({ readonly_status: 'readonly' });
    const uri = window.location.href.split('/').pop();
    console.log('pawas', uri);
    fetch(url + '/api/current/?token=' + localStorage.getItem('invalid'), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.detail === 'Given token not valid for any token type') {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('is_applicant');
            localStorage.removeItem('is_admin');
            localStorage.removeItem('is_candidate');
            localStorage.removeItem('is_pre_screen_applicant');
            window.location.href = '/login';
          } else {
            console.log('Hello');
            console.log('result', result, result);
            if (result.length > 0) {
              localStorage.setItem('cv-id', result[0].id);
            }
          }
        },
        (error) => {
          console.log('error', error);
        }
      );

    if (uri === '#edit') {
      if (
        localStorage.getItem('cv-id-preview') &&
        localStorage.getItem('from-summary')
      ) {
        var id = localStorage.getItem('cv-id-preview');
      } else {
        var id = localStorage.getItem('cv-id');
      }
      console.log('cv-id', id);
      this.setState({ cv_id: id });
      localStorage.removeItem('from-summary');

      fetch(url + '/api/v1/user/submit-details/' + id + '/', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result', result);
            this.setState({ perssonal_detail: result });
            if (result.filepath && result.date_of_birth) {
              const uri = result.filepath.split('/').pop();

              let date = result.date_of_birth.split('-');
              console.log('date', date);
              let year = date[0];
              let month = date[1];
              date = date[2];
              console.log('year', year);
              console.log('month', month);
              console.log('date', date);
              console.log('result', result.county);
              this.setState({
                date: date,
                year: year,
                month: month,
              });

              this.setState({ setuploadcv_validate: uri });
              this.setState({ setuploadcv_exists: true });
              this.setState({ upload_cv_name: uri });
              this.setState({ upload_cv: result.filepath.name });
              console.log('cv-uri', uri);
            }
            if (result.profile_picture) {
              const uri = result.profile_picture.split('/').pop();
              this.setState({ setuploadimage_validate: uri });
              this.setState({ setuploadiMge_exists: true });
              this.setState({ upload_imge_name: uri });
              this.setState({ upload_image: result.profile_picture.name });
              console.log('image-uri', uri);
            }

            console.log('address', result.address);
            this.state.address_list.push(result.address);
            this.setState({
              email: result.email,
              firstname: result.first_name,
              lastname: result.last_name,
              address: result.address,
              address_list: this.state.address_list,
              zipcode: result.zipcode,
              city: result.city,
              country: result.country,
              county: result.county,
              address_line_1: result.address_line_1,
              address_line_2: result.address_line_2,
              address_line_3: result.address_line_3,
              title: result.name_title,
              right_to_work: result.right_to_work,
              setconfirmpassword_validate: 'Re-Enter Your Password',
              edit_status: true,
              jobtitle: result.title,
              county: result.county,
            });
            // this.getDataPostCode();
            var a = `${result.address_line_1}, ${result.address_line_2},`;
            // console.log(a,this.state.address_list);
            console.log(this.state.address_list);

            this.setState({ address: a });
            this.state.address_list.push(a);
            this.setState({ address_list: this.state.address_list });
            console.log(this.state.address_list);

            // this.state.address_list.map((each)=>{
            //   console.log(each, a)
            //   if(each.indexOf(a) != -1){
            //     console.log("FOUND");
            //     this.setState({address:a});
            //     return;
            //   }
            // })
            this.setState({ update_record: '' });
            if (result.update_record) {
              console.log('result.update_record', result.update_record);
              this.setState({ update_record: result.update_record + ',' });
            }
            var updated = console.log('updated', updated);
            if (result.update_record) {
              var final_updated = JSON.stringify(
                this.state.update_record + updated
              );
            } else {
              var final_updated = JSON.stringify(updated);
            }
            this.setState({ update_record_second: final_updated });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      let data_refresh = { refresh: localStorage.getItem('refresh') };
      fetch(url + '/api/token/refresh/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data_refresh),
      })
        .then((response) => {
          if (response['status'] === 201 || response['status'] === 200) {
            return response.json();
          } else if (response['status'] === 401) {
            this.showCustomModal();
            this.setState({ authResponse: 'Some Thing went wrong' });
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('is_admin');
            localStorage.removeItem('is_candidate');
            localStorage.removeItem('is_applicant');
          }
        })
        .then((result) => {
          if (result) {
            console.log('result.access', result.access);
            localStorage.setItem('token', result.access);
          }
        });
      fetch(url + '/api/current/?token=' + localStorage.getItem('invalid'), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.detail === 'Given token not valid for any token type') {
              localStorage.removeItem('token');
              localStorage.removeItem('refresh');
              localStorage.removeItem('is_applicant');
              localStorage.removeItem('is_admin');
              localStorage.removeItem('is_candidate');
              localStorage.removeItem('is_pre_screen_applicant');
              window.location.href = '/login';
            } else {
              console.log('Hello');
              console.log('result', result, result);
              if (result.length > 0) {
                localStorage.setItem('cv-id', result[0].id);
                this.setState({ firstname: result[0].first_name });
                this.setState({ lastname: result[0].last_name });
                this.setState({ email: result[0].email });
                console.log(
                  'result ni h ye',
                  result,
                  this.state.firstname,
                  this.state.email
                );
              }
            }
          },
          (error) => {
            console.log('error', error);
          }
        );
    }
    fetch(url + '/api/v1/user/title/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ title_type: result });
          console.log('result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/api/v1/user/right-to-work/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ right_to_work_type: result });
          console.log('result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  getDataPostCode = () => {
    var data = this.state.zipcode;
    this.setState({ address_list: [] });

    if (data.length > 5) {
      console.log('DSD');
      this.setState({ address: '' });
      fetch(
        'https://api.getaddress.io/find/' +
          data +
          '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => {
          if (res.status == 400) {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter the valid UK postcode',
            });
          } else if (res.status == 200 || res.status == 201) {
            return res.json();
          }
        })
        .then(
          (result) => {
            if (result) {
              this.setState({ address_list: result.addresses });
              var postcode = this.state.zipcode;
              var data = this.state.address_list[0];
              //     fetch(("https://api.getaddress.io/find/"+postcode+"/"+ data +"?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608&expand=true"), {
              //       method: 'GET',
              //       headers: {
              //           'Content-Type': "application/json",
              //       }
              //       })
              //     .then(res =>{
              //       if(res.status == 400){
              //           console.log('Not found')
              //       }else if(res.status == 200 || res.status == 201){
              //         return res.json();
              //       }
              //     })
              //     .then(
              //       (result) => {
              //         console.log(result);
              //           console.log('result-country',result['addresses'][0]['country'])
              //           console.log('result-line_1',result['addresses'][0]['line_1'])
              //           console.log('result-line_2',result['addresses'][0]['line_2'])
              //           console.log('result-town_or_city',result['addresses'][0]['town_or_city'])
              //           console.log('result-county',result['addresses'][0]['county'])
              //           console.log('result-district',result['addresses'][0]['district'])
              //           this.setState({ city: result['addresses'][0]['district']+','+ result['addresses'][0]['town_or_city']})
              //           this.setState({ country: result['addresses'][0]['country']})
              //           this.setState({ county: result['addresses'][0]['county']})
              //           console.log('this.state.country',this.state.country)
              //           console.log('this.state.city',this.state.city)
              //           console.log('this.state.county',this.state.county)

              //           this.setState({address_line_1:result['addresses'][0]['line_1']})
              //           this.setState({address_line_2:result['addresses'][0]['line_2']})
              //           this.setState({address_line_3:result['addresses'][0]['line_3']})
              //           this.setState({latitude:result.latitude})
              //           this.setState({longitude:result.longitude})

              //           this.setState({address1: result['addresses'][0]['formatted_address'][0]})

              //       },
              //       (error) => {
              //         console.log('error',error)
              //       })
              // //     console.log(this.state.address)
              // }
              //     this.setState({address:""})
            }
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the valid UK postcode' });
    }
  };

  handelData = (identity, data) => {
    if (identity === 'email') {
      this.setState({ email: data });
    } else if (identity === 'jobtitle') {
      console.log('data', data);
      this.setState({ jobtitle: data });
    } else if (identity == 'title') {
      this.setState({ title: data });
    } else if (identity === 'firstname') {
      console.log('data', data);
      if (data == '' || /^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/.test(data)) {
        this.setState({ firstname: data });
        this.setState({ setfirstname_validate: '' });
      } else if (data.length <= 0) {
        this.setState({ setfirstname_validate: 'This field is required' });
      } else {
        this.setState({
          setfirstname_validate: 'Please Enter a valid firstname',
        });
      }
    } else if (identity === 'lastname') {
      console.log('data', data);
      if (data == '' || /^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/.test(data)) {
        this.setState({ lastname: data });
        this.setState({ setlastname_validate: '' });
      } else if (data.length <= 0) {
        this.setState({ setlastname_validate: 'This field is required' });
      } else {
        this.setState({
          setlastname_validate: 'Please Enter a valid lastname',
        });
      }
    } else if (identity === 'county') {
      if (data == '' || data.length > 0) {
        this.setState({ county: data });
        this.setState({ setcounty_validate: '' });
      } else {
        this.setState({ setcounty_validate: 'This field is required' });
      }
    } else if (identity === 'year') {
      console.log('data', data);

      if (data.length > 0) {
        this.setState({ year: data });
        this.setState({ setyear_validate: '' });
      } else {
        this.setState({ setyear_validate: 'This field is required' });
      }
    } else if (identity === 'month') {
      console.log('date', data);
      if (data.length > 0) {
        this.setState({ month: data });
        this.setState({ setmonth_validate: '' });
      } else {
        this.setState({ setmonth_validate: 'This field is required' });
      }
    } else if (identity === 'date') {
      if (data.length > 0) {
        this.setState({ date: data });
        this.setState({ setdate_validate: '' });
      } else {
        this.setState({ setdate_validate: 'This field is required' });
      }
    } else if (identity === 'address') {
      console.log('data', data);

      var postcode = this.state.zipcode;

      //   if(data === '' ||  data === "Select the address"){
      //     this.setState({ setaddress_validate: 'This field is required' })
      //     this.showCustomModal()
      //   this.setState({authResponse:'Address line 1 is required'})
      // }

      this.setState({ address: data });

      this.setState({ setaddress_validate: '' });

      if (data !== '') {
        fetch(
          'https://api.getaddress.io/find/' +
            postcode +
            '/' +
            data +
            '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608&expand=true',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((res) => {
            if (res.status == 400) {
              console.log('Not found');
            } else if (res.status == 200 || res.status == 201) {
              return res.json();
            }
          })
          .then(
            (result) => {
              console.log(result);
              console.log('result-country', result['addresses'][0]['country']);
              console.log('result-line_1', result['addresses'][0]['line_1']);
              console.log('result-line_2', result['addresses'][0]['line_2']);
              console.log(
                'result-town_or_city',
                result['addresses'][0]['town_or_city']
              );
              console.log('result-county', result['addresses'][0]['county']);
              console.log(
                'result-district',
                result['addresses'][0]['district']
              );
              this.setState({
                city:
                  result['addresses'][0]['district'] +
                  ',' +
                  result['addresses'][0]['town_or_city'],
              });
              this.setState({ country: result['addresses'][0]['country'] });
              this.setState({ county: result['addresses'][0]['county'] });
              console.log('this.state.country', this.state.country);
              console.log('this.state.city', this.state.city);
              console.log('this.state.county', this.state.county);

              this.setState({
                address_line_1: result['addresses'][0]['line_1'],
              });
              this.setState({
                address_line_2: result['addresses'][0]['line_2'],
              });
              this.setState({
                address_line_3: result['addresses'][0]['line_3'],
              });
              this.setState({ latitude: result.latitude });
              this.setState({ longitude: result.longitude });

              this.setState({
                address1: result['addresses'][0]['formatted_address'][0],
              });
            },
            (error) => {
              console.log('error', error);
            }
          );
      }
    } else if (identity === 'address1') {
      this.setState({ address1: data });
      console.log('data', data);
    } else if (identity === 'zipcode') {
      console.log('data', data);
      if (data == '' || data.length > 0) {
        this.setState({ zipcode: data });
        this.setState({ setzipcode_validate: '' });
      } else {
        this.setState({ setzipcode_validate: 'This field is required' });
      }
    } else if (identity === 'country') {
      console.log('data', data);

      if (data == '' || data.length > 0) {
        this.setState({ country: data });
        this.setState({ setcountry_validate: '' });
      } else {
        this.setState({ setcountry_validate: 'This field is required' });
      }
    } else if (identity === 'right_to_work') {
      console.log('data', data);
      if (data.length > 0) {
        this.setState({ right_to_work: data });
        this.setState({ right_to_work_validate: '' });
      } else {
        this.setState({ right_to_work_validate: 'This field is required' });
      }
    } else if (identity === 'city') {
      console.log('data', data);
      if (data == '' || data.length > 0) {
        this.setState({ city: data });
        this.setState({ setcountry_validate: '' });
      } else {
        this.setState({ setcountry_validate: 'This field is required' });
      }
    } else if (identity === 'upload_cv') {
      if (data) {
        var re = /(\.pdf|\.doc|\.docx|\.png|\.jpeg|\.jpg|\.gif)$/i;
        if (!re.exec(data.name)) {
          this.setState({
            setuploadcv_validate:
              'File not supported! Please Upload .pdf, .doc, .docx, .jpg, .jpeg, .png, .gif file',
          });
        } else {
          if (data) {
            this.setState({ upload_cv_name: data.name });
            this.setState({ upload_cv: data });
            this.setState({ setuploadcv_validate: data.name });
          } else {
            this.setState({ setuploadcv_validate: 'This field is required' });
          }
        }
        console.log(
          this.state.upload_cv_name,
          data.name,
          this.state.setuploadcv_validate
        );
      }
    } else if (identity === 'upload_image') {
      if (data) {
        console.log('Uploading iamge ', data);
        var re = /(\.pdf|\.doc|\.docx|\.png|\.jpeg|\.jpg|\.gif)$/i;
        if (!re.exec(data.name)) {
          this.setState({
            setuploadimage_validate:
              'File not supported! Please Upload .pdf, .doc, .docx, .jpg, .jpeg, .png, .gif file',
          });
        } else {
          if (data) {
            this.setState({ upload_image_name: data.name });
            this.setState({ upload_image: data });
            this.setState({ setuploadimage_validate: data.name });
          } else {
            this.setState({
              setuploadimage_validate: 'This field is required',
            });
          }
        }
        console.log(
          'IMG',
          this.state.upload_image_name,
          data.name,
          this.state.setuploadimage_validate
        );
      }
    }
  };

  handelSummit = async () => {
    localStorage.removeItem('flow');

    let form_data = new FormData();
    if (this.state.upload_cv) {
      form_data.append(
        'filepath',
        this.state.upload_cv,
        this.state.upload_cv.name
      );
    }
    if (this.state.upload_image) {
      form_data.append(
        'profile_picture',
        this.state.upload_image,
        this.state.upload_image.name
      );
    }
    form_data.append('email', this.state.email);
    form_data.append('first_name', this.state.firstname);
    form_data.append('last_name', this.state.lastname);
    form_data.append(
      'date_of_birth',
      this.state.year + '-' + this.state.month + '-' + this.state.date
    );
    form_data.append('zipcode', this.state.zipcode);
    form_data.append('country', this.state.country);
    form_data.append('city', this.state.city);
    form_data.append('title', this.state.jobtitle);
    form_data.append('name_title', this.state.title);
    form_data.append('right_to_work', this.state.right_to_work);
    form_data.append('county', this.state.county);
    form_data.append('address_line_1', this.state.address_line_1);
    form_data.append('address_line_2', this.state.address_line_2);
    form_data.append('address_line_3', this.state.address_line_3);
    form_data.append('latitude', this.state.latitude);
    form_data.append('longitude', this.state.longitude);

    // let data={
    //    "first_name": this.state.firstname,
    //    "last_name": this.state.lastname,
    //    "email": this.state.email,
    //    "password": this.state.password,
    //    "date_of_birth": this.state.year+ '-' + this.state.date + '-' + this.state.month ,
    //    "address": this.state.address + ',' + this.state.address1,
    //    "zipcode": this.state.zipcode,
    //    "country": this.state.country,
    //    "city": this.state.city,
    //    "title": this.state.jobtitle,
    //    "right_to_work": this.state.jobtitle,
    //    "filepath": this.state.upload_cv,
    //}

    if (
      this.state.firstname === '' ||
      this.state.title === '' ||
      this.state.last_name === '' ||
      this.state.email === '' ||
      this.state.address === '' ||
      this.state.zipcode === '' ||
      this.state.upload_cv === null ||
      this.state.right_to_work === '' ||
      this.state.year === '' ||
      this.state.month === '' ||
      this.state.date === ''
    ) {
      if (this.state.firstname === '') {
        this.setState({ setfirstname_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'First Name is required' });
      }
      if (this.state.last_name === '') {
        this.setState({ setlastname_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Last Name is required' });
      }
      if (this.state.title === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Title is required' });
      }

      if (this.state.address === '') {
        this.setState({ setaddress_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Select the address' });
      }
      if (this.state.zipcode === '') {
        this.setState({ setzipcode_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'PostCode is required' });
      }
      /*
    if(this.state.country === ''){
        this.setState({ setcountry_validate: 'This field is required' })
        this.showCustomModal()
		this.setState({authResponse:'Country is required'})
    }
    */
      if (!this.state.edit_status) {
        if (this.state.upload_cv === null) {
          this.setState({ setuploadcv_validate: 'This field is required' });
          this.showCustomModal();
          this.setState({ authResponse: 'Upload Cv to proceed' });
        }
      }
      if (this.state.upload_cv === null) {
        this.setState({ setuploadcv_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Upload Cv to proceed' });
      }
      if (this.state.jobtitle === '') {
        this.setState({ setjob_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Job Title is required' });
      }
      if (this.state.date === '') {
        this.setState({ setdate_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Date is required' });
      }
      if (this.state.month === '') {
        this.setState({ setmonth_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Month is required' });
      }
      if (this.state.year === '') {
        this.setState({ setyear_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Year is required' });
      }
      if (this.state.right_to_work === '') {
        this.setState({ right_to_work_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'right to work is required' });
      }
      if (this.state.email === '') {
        this.setState({ setemail_validate: 'This field is required' });
        this.showCustomModal();
        this.setState({ authResponse: 'Email is required' });
      }
      /*
    if(this.state.city === ''){
        this.setState({ setcity_validate: 'This field is required' })
        this.showCustomModal()
		this.setState({authResponse:'City is required'})
    }
    if(this.state.county === ''){
        this.setState({ setcounty_validate: 'This field is required' })
        this.showCustomModal()
		this.setState({authResponse:'County is required'})
    }
    */
    } else {
      if (this.state.edit_status) {
        CVEditApi(form_data, this);
      } else {
        CVRegistrationApi(form_data, this);
      }
    }
  };

  render() {
    return (
      <CvPageView
        lastname={this.state.lastname}
        firstname={this.state.firstname}
        handelData={this.handelData}
        title_type={this.state.title_type}
        title={this.state.title}
        right_to_work_type={this.state.right_to_work_type}
        years={this.years}
        months_list={this.state.months_list}
        date_list={this.state.date_list}
        setpassword_validate={this.state.setpassword_validate}
        setemail_validate={this.state.setemail_validate}
        setfirstname_validate={this.state.setfirstname_validate}
        setlastname_validate={this.state.setlastname_validate}
        setjob_validate={this.state.setjob_validate}
        handelSummit={this.handelSummit}
        setconfirmpassword_validate={this.state.setconfirmpassword_validate}
        setaddress_validate={this.state.setaddress_validate}
        setzipcode_validate={this.state.setzipcode_validate}
        setcountry_validate={this.state.setcountry_validate}
        setuploadcv_validate={this.state.setuploadcv_validate}
        setuploadimage_validate={this.state.setuploadimage_validate}
        setdate_validate={this.state.setdate_validate}
        setmonth_validate={this.state.setmonth_validate}
        setyear_validate={this.state.setyear_validate}
        right_to_work_validate={this.state.right_to_work_validate}
        hideCustomModal={this.hideCustomModal}
        showCustomModal={this.showCustomModal}
        modal_show={this.state.modal_show}
        authResponse={this.state.authResponse}
        address={this.state.address}
        address_list={this.state.address_list}
        zipcode={this.state.zipcode}
        country={this.state.country}
        city={this.state.city}
        right_to_work={this.state.right_to_work}
        email={this.state.email}
        date={this.state.date}
        month={this.state.month}
        year={this.state.year}
        edit_status={this.state.edit_status}
        jobtitle={this.state.jobtitle}
        setcounty_validate={this.state.setcounty_validate}
        county={this.state.county}
        setcity_validate={this.state.setcity_validate}
        readonly_status={this.state.readonly_status}
        getDataPostCode={this.getDataPostCode}
      />
    );
  }
}

export default CvPageComponent;
